// import { REGEX_CONSTANT } from "../../../constant/regexConstant";

import { REGEX_CONSTANT } from "../../../../constant/regexConstant";

export const validDT = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "char_value":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "price_distance":
      if (data?.length<1) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }  else if (!REGEX_CONSTANT.FLOAT.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("GEOTREE:FIELD_NAME"),
        });
      }else if (data<0) {
        error[namespace] = translate("Value must be more or equal than 0", {
          field: translate("GEOTREE:FIELD_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      case "price_weight":
        if (data?.length<1) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        }  else if (!REGEX_CONSTANT.FLOAT.test(data)) {
          error[namespace] = translate("Invalid Format", {
            field: translate("GEOTREE:FIELD_NAME"),
          });
        }else if (data<0) {
          error[namespace] = translate("Value must be more or equal than 0", {
            field: translate("GEOTREE:FIELD_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "price_volume":
          if (data?.length<1) {
            error[namespace] = translate("COMMON:REQUIRE", {
              field: translate("CUSTOMER:ADDITIONAL_NAME"),
            });
          }  else if (!REGEX_CONSTANT.FLOAT.test(data)) {
            error[namespace] = translate("Invalid Format", {
              field: translate("GEOTREE:FIELD_NAME"),
            });
          }else if (data<0) {
            error[namespace] = translate("Value must be more or equal than 0", {
              field: translate("GEOTREE:FIELD_NAME"),
            });
          } else {
            error[namespace] = null;
          }
          break;
          case "price_time":
            if (data?.length<1) {
              error[namespace] = translate("COMMON:REQUIRE", {
                field: translate("CUSTOMER:ADDITIONAL_NAME"),
              });
            }  else if (!REGEX_CONSTANT.FLOAT.test(data)) {
              error[namespace] = translate("Invalid Format", {
                field: translate("GEOTREE:FIELD_NAME"),
              });
            }else if (data<0) {
              error[namespace] = translate("Value must be more or equal than 0", {
                field: translate("GEOTREE:FIELD_NAME"),
              });
            } else {
              error[namespace] = null;
            }
            break;
            case "base_price":
              if (data?.length<1) {
                error[namespace] = translate("COMMON:REQUIRE", {
                  field: translate("CUSTOMER:ADDITIONAL_NAME"),
                });
              }  else if (!REGEX_CONSTANT.FLOAT.test(data)) {
                error[namespace] = translate("Invalid Format", {
                  field: translate("GEOTREE:FIELD_NAME"),
                });
              }else if (data<0) {
                error[namespace] = translate("Value must be more or equal than 0", {
                  field: translate("GEOTREE:FIELD_NAME"),
                });
              } else {
                error[namespace] = null;
              }
              break;
              case "delivery_code":
              if (!data) {
                error[namespace] = translate("COMMON:REQUIRE", {
                  field: translate("CUSTOMER:ADDITIONAL_NAME"),
                });
              }else {
                error[namespace] = null;
              }
              break;
              case "description":
                if (!data) {
                  error[namespace] = translate("COMMON:REQUIRE", {
                    field: translate("CUSTOMER:ADDITIONAL_NAME"),
                  });
                }else {
                  error[namespace] = null;
                }
                break; case "delivery_type":
                if (!data) {
                  error[namespace] = translate("COMMON:REQUIRE", {
                    field: translate("CUSTOMER:ADDITIONAL_NAME"),
                  });
                }else {
                  error[namespace] = null;
                }
                break;
    default:
      break;
  }
  return error;
};
